// Mock data for Hipro Technologies

export const company = {
  name: 'Hipro Technologies',
  email: 'info@hiprotechnologies.com',
  website: 'www.hiprotechnologies.com',
  phone: '+91-9359819036',
  phoneRaw: '+919359819036',
  logo: 'https://customer-assets-39nsmqrw.emergentagent.net/job_615796fa-3ff9-4e3d-b2f2-06cf127a7f99/artifacts/8b6q69tb_Hipro%20Logo.png',
  locations: ['India', 'USA', 'UK', 'UAE', 'Malaysia', 'Netherlands', 'Hong Kong'],
  since: 2015,
};

export const navLinks = [
  { label: 'Home', href: '/#home' },
  { label: 'About', href: '/#about' },
  { label: 'Services', href: '/#services' },
  { label: 'Portfolio', href: '/#portfolio' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Industries', href: '/#industries' },
  { label: 'Insights', href: '/#insights' },
  { label: 'Contact', href: '/#contact' },
];

export const heroStats = [
  { value: '13+', label: 'Years Experience' },
  { value: '5', label: 'Global Offices' },
  { value: '1000+', label: 'Projects Delivered' },
  { value: '98%', label: 'Client Retention' },
];

export const services = [
  {
    id: 'design',
    tag: 'Creative',
    title: 'Design & Creative',
    subtitle: 'Crafting beautiful, intuitive digital experiences.',
    image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?crop=entropy&cs=srgb&fm=jpg&q=85',
    items: [
      'Website Design',
      'Graphic Design',
      'UI/UX Design',
      'Branding & Identity',
      'Video Production',
      'Social Media Creatives',
      'Motion Graphics',
    ],
  },
  {
    id: 'development',
    tag: 'Popular',
    title: 'Development & Technology',
    subtitle: 'Building robust, scalable applications and systems.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?crop=entropy&cs=srgb&fm=jpg&q=85',
    items: [
      'Mobile App Development',
      'eCommerce Development',
      'Custom Software Development',
      'Web Application Development',
      'ERP/CRM Solutions',
      'API Integrations',
      'SaaS Development',
    ],
  },
  {
    id: 'marketing',
    tag: 'High-Demand',
    title: 'Marketing & Growth',
    subtitle: 'Data-driven strategies to scale your business.',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=85',
    items: [
      'Digital Marketing',
      'Performance Marketing',
      'SEO & GEO Services',
      'Meta Ads',
      'Google Ads',
      'Lead Generation',
      'Social Media Management',
      'Content Marketing',
    ],
  },
];

export const portfolioCategories = ['Website', 'Software', 'Graphics'];

export const portfolioItems = [
  { id: 1, category: 'Website', title: 'Finance Analytics Platform', tag: 'Finance', image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 2, category: 'Software', title: 'AI Assistant Dashboard', tag: 'Artificial-Intelligence', image: 'https://images.unsplash.com/photo-1686061592689-312bbfb5c055?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 3, category: 'Website', title: 'Workspace Booking Portal', tag: 'Coworking-Space', image: 'https://images.unsplash.com/photo-1686061594225-3e92c0cd51b0?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 4, category: 'Software', title: 'Enterprise ERP Suite', tag: 'ERP', image: 'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 5, category: 'Website', title: 'Healthcare Booking App', tag: 'Healthcare', image: 'https://images.unsplash.com/photo-1480694313141-fce5e697ee25?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 6, category: 'Graphics', title: 'Retail Brand Identity', tag: 'Branding', image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?crop=entropy&cs=srgb&fm=jpg&q=85' },
];

export const techStacks = {
  'Front End': [
    { name: 'React JS', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg' },
    { name: 'Angular.JS', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/angularjs/angularjs-original.svg' },
    { name: 'Next.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg' },
    { name: 'Vue.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg' },
    { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg' },
    { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg' },
    { name: 'Bootstrap', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/bootstrap/bootstrap-original.svg' },
    { name: 'Tailwind', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg' },
  ],
  'Backend': [
    { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg' },
    { name: 'Python', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg' },
    { name: 'Java', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original.svg' },
    { name: 'PHP', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg' },
    { name: 'Django', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/django/django-plain.svg' },
    { name: '.NET', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dot-net/dot-net-original.svg' },
    { name: 'GraphQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/graphql/graphql-plain.svg' },
    { name: 'FastAPI', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/fastapi/fastapi-original.svg' },
  ],
  'Mobile': [
    { name: 'Flutter', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg' },
    { name: 'React Native', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg' },
    { name: 'Android', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/android/android-original.svg' },
    { name: 'Swift', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/swift/swift-original.svg' },
    { name: 'Kotlin', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kotlin/kotlin-original.svg' },
    { name: 'Ionic', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/ionic/ionic-original.svg' },
  ],
  'Database': [
    { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original.svg' },
    { name: 'PostgreSQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg' },
    { name: 'MySQL', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg' },
    { name: 'Redis', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg' },
    { name: 'Firebase', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-plain.svg' },
    { name: 'Elasticsearch', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/elasticsearch/elasticsearch-original.svg' },
  ],
  'Cloud & DevOps': [
    { name: 'AWS', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg' },
    { name: 'Azure', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/azure/azure-original.svg' },
    { name: 'Google Cloud', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/googlecloud/googlecloud-original.svg' },
    { name: 'Docker', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg' },
    { name: 'Kubernetes', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kubernetes/kubernetes-plain.svg' },
    { name: 'Jenkins', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jenkins/jenkins-original.svg' },
  ],
};

export const industries = [
  { key: 'healthcare', name: 'Healthcare', desc: 'HIPAA-compliant healthcare software, telemedicine and EHR platforms.', icon: 'HeartPulse' },
  { key: 'education', name: 'Education', desc: 'Modern LMS, e-learning and school management platforms.', icon: 'GraduationCap' },
  { key: 'finance', name: 'Finance', desc: 'Secure fintech products, banking, and wealth management apps.', icon: 'Landmark' },
  { key: 'retail', name: 'Retail', desc: 'Modern eCommerce, POS and omnichannel retail solutions.', icon: 'ShoppingBag' },
  { key: 'manufacturing', name: 'Manufacturing', desc: 'Smart automation and industry 4.0 software solutions.', icon: 'Factory' },
  { key: 'realestate', name: 'Real Estate', desc: 'Property management, listing portals and CRM platforms.', icon: 'Building2' },
  { key: 'travel', name: 'Travel', desc: 'OTA platforms, booking engines and travel management.', icon: 'Plane' },
  { key: 'automotive', name: 'Automotive', desc: 'Dealer platforms, fleet, and connected vehicle solutions.', icon: 'Car' },
  { key: 'technology', name: 'Technology', desc: 'SaaS platforms, developer tools and enterprise software.', icon: 'Cpu' },
];

export const process = [
  { step: '01', tag: 'Discovery & Scope', title: 'Requirement Analysis', items: ['Business analysis', 'Target users', 'Requirements', 'Project scope'] },
  { step: '02', tag: 'Wireframe & UI', title: 'UI/UX Design Process', items: ['Wireframing', 'UI Design', 'Prototyping', 'User testing'] },
  { step: '03', tag: 'Full-Stack Dev', title: 'Application Development', items: ['Code quality', 'Version control', 'Best practices', 'Testing integration'] },
  { step: '04', tag: 'QA & Security', title: 'Quality Testing Process', items: ['Functional tests', 'Performance', 'Security', 'Device testing'] },
  { step: '05', tag: 'Store & Cloud', title: 'Application Deployment', items: ['Store submission', 'App review', 'ASO optimization', 'Launch process'] },
  { step: '06', tag: '24/7 SLA Support', title: 'Support and Scaling', items: ['Bug fixes', 'Updates', 'Scaling', 'Support'] },
];

export const insights = [
  { id: 1, title: 'How AI Automation is Reshaping IT Services in 2025', category: 'AI & Automation', date: 'July 10, 2025', image: 'https://images.unsplash.com/photo-1651340527836-263c5072968e?crop=entropy&cs=srgb&fm=jpg&q=85', excerpt: 'Discover how AI-first workflows are helping enterprises cut delivery times by 40% and elevate customer experiences.' },
  { id: 2, title: 'Building Global SaaS: Compliance Checklist for USA, UK & EU', category: 'SaaS', date: 'June 24, 2025', image: 'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?crop=entropy&cs=srgb&fm=jpg&q=85', excerpt: 'A pragmatic guide to GDPR, SOC 2, HIPAA and CCPA readiness for growing SaaS platforms.' },
  { id: 3, title: 'Nearshore vs Offshore: Choosing the Right IT Partner', category: 'Growth', date: 'June 05, 2025', image: 'https://images.unsplash.com/photo-1651340608985-d25cc73156e8?crop=entropy&cs=srgb&fm=jpg&q=85', excerpt: 'A CTO’s framework to compare cost, quality, and collaboration when selecting a global engineering partner.' },
];

export const faqs = [
  { q: 'What services does Hipro Technologies offer?', a: 'We deliver end-to-end IT services including web & mobile development, custom software, cloud engineering, AI automation, and digital marketing tailored for startups and enterprises across USA, UK, Europe, UAE, Malaysia, Hong Kong and India.' },
  { q: 'What is your development process for web and mobile app projects?', a: 'We follow a proven agile process: discovery, UI/UX design, full-stack development, QA & security, deployment and 24/7 support to ensure high-quality on-time delivery.' },
  { q: 'What engagement models do you offer?', a: 'Fixed-Price, Time & Material, and Dedicated Team engagements are available so you can match commercial risk with project clarity.' },
  { q: 'How much does software or mobile app development cost?', a: 'Cost depends on scope, features, platforms and integrations. Book a free consultation and we will share a detailed estimate within 24 hours.' },
  { q: 'How long does it take to develop a website or mobile application?', a: 'A typical marketing website takes 4–6 weeks. Complex mobile applications and enterprise platforms run 3–9 months depending on scope.' },
  { q: 'Do you work with startups and enterprises?', a: 'Yes. From MVPs for founders to digital transformation for Fortune-500 companies, we scale our teams to fit your stage.' },
  { q: 'Which technologies do you use?', a: 'React, Next.js, Node.js, Python, .NET, Flutter, React Native, AWS, Azure and Google Cloud — chosen per project to maximise value.' },
  { q: 'Do you provide post-launch support and maintenance?', a: 'Absolutely. We offer 24/7 SLA-backed maintenance, monitoring and continuous improvement across all engagements.' },
];

export const testimonials = [
  { name: 'Sarah Mitchell', role: 'VP Engineering, FinNova (USA)', quote: 'Hipro delivered a scalable trading platform 3 weeks ahead of schedule. Their engineers feel like an extension of our team.', avatar: 'https://i.pravatar.cc/120?img=47' },
  { name: 'James O’Connor', role: 'Founder, LedgerUK (UK)', quote: 'Communication, code quality and design were world-class. We shipped our MVP in 10 weeks and raised our seed round.', avatar: 'https://i.pravatar.cc/120?img=12' },
  { name: 'Marco Bianchi', role: 'CTO, Retailly (Italy)', quote: 'From cloud architecture to Meta Ads, they own outcomes. Our revenue grew 2.4x in the first year.', avatar: 'https://i.pravatar.cc/120?img=15' },
  { name: 'Aarav Sharma', role: 'Product Lead, Zenith (India)', quote: 'Beautiful UI, rock-solid backend and thoughtful QA. Hipro is our default technology partner now.', avatar: 'https://i.pravatar.cc/120?img=32' },
];

export const serviceOptions = [
  'Website Design & Development',
  'Mobile App Development',
  'Custom Software / SaaS',
  'AI & Automation',
  'Cloud & DevOps',
  'Digital Marketing / SEO',
  'UI/UX Design',
  'Other',
];

export const hearAboutOptions = ['Google Search', 'Referral', 'LinkedIn', 'Instagram', 'Clutch / GoodFirms', 'Other'];

export const countries = [
  { code: 'IN', name: 'India', dial: '+91' },
  { code: 'US', name: 'United States', dial: '+1' },
  { code: 'GB', name: 'United Kingdom', dial: '+44' },
  { code: 'IT', name: 'Italy', dial: '+39' },
  { code: 'SG', name: 'Singapore', dial: '+65' },
  { code: 'AE', name: 'United Arab Emirates', dial: '+971' },
  { code: 'CA', name: 'Canada', dial: '+1' },
  { code: 'AU', name: 'Australia', dial: '+61' },
  { code: 'DE', name: 'Germany', dial: '+49' },
  { code: 'FR', name: 'France', dial: '+33' },
];
